@if (active) {
  <div class="loading-container">
    <div class="box" [ngStyle]="{ 'max-width.px': maxWidth }">
      <div class="spinner">
        <div class="spin-accent"></div>
        <div class="center"></div>
      </div>
      <div class="heading-main" [innerHTML]="loadingMessage">Loading</div>
      @if (secondaryMessage && secondaryMessage.length > 0) {
        <div>
          <hr aria-hidden="true" class="fill" />
          <span [innerHTML]="secondaryMessage"></span>
        </div>
      }
    </div>
  </div>
}
